"use client";

import { FocusTrap } from "focus-trap-react";
import { motion } from "motion/react";
import { useMediaQuery } from "usehooks-ts";

import { Portal } from "./Portal";
import { Auth } from "../auth/auth";

export const SignInDialog = function ({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}) {
  const isDesktopScreen = useMediaQuery("(min-width: 640px)");

  const close = function () {
    setIsOpen(false);
  };

  return (
    <Portal>
      <FocusTrap
        active={isOpen}
        focusTrapOptions={{
          initialFocus: "#cart-heading",
        }}
      >
        <div role="dialog" aria-labelledby="cart-heading" tabIndex={-1}>
          <motion.div
            className={`${
              isDesktopScreen ? "w-96" : "w-full"
            } fixed z-50 top-0 right-0 bottom-0 bg-white overflow-auto overscroll-contain`}
            initial="closed"
            animate={isOpen ? "open" : "closed"}
            variants={{
              open: isDesktopScreen ? { x: "0", y: 0 } : { y: "0", x: 0 },
              closed: isDesktopScreen
                ? { x: "100%", y: 0 }
                : { x: 0, y: "100%" },
            }}
            transition={{
              type: "spring",
              bounce: 0.2,
              duration: 0.4,
            }}
            style={{
              transformOrigin: "top center",
              boxShadow: isDesktopScreen
                ? "0px 30px 50px 0px rgba(0, 0, 0, 0.20), 0px 15px 20px 0px rgba(0, 0, 0, 0.10), 0px 0px 4px 0px rgba(0, 0, 0, 0.07)"
                : "",
            }}
          >
            <div className="flex flex-col h-full">
              <div className="flex items-center justify-between p-6 bg-white/95 sticky top-0 z-50 shrink-0">
                <p
                  id="cart-heading"
                  className="flex items-center font-bold uppercase text-xl"
                  tabIndex={0}
                >
                  Sign In
                </p>
                <button className="underline" onClick={close}>
                  close
                </button>
              </div>
              <div className="relative grow py-4 px-6">
                <Auth onSuccess={close} />
              </div>
            </div>
          </motion.div>
        </div>
      </FocusTrap>
    </Portal>
  );
};
